// src/components/CommonTableActions.jsx
import React from 'react';
import { Button, TextField, IconButton, InputAdornment } from '@mui/material';
import { Search, Refresh, SaveAlt } from '@mui/icons-material';

const CommonTableActions = ({
  searchTerm,
  setSearchTerm,
  handleExport,
  onRefresh,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <TextField
        variant="outlined"
        size="small"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        sx={{
          backgroundColor: '#ffffff',
          width: '300px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#00308F',
            },
            '&:hover fieldset': {
              borderColor: '#00207E',
            },
          },
        }}
      />
      <Button
        onClick={handleExport}
        startIcon={<SaveAlt />}
        variant="contained"
        color="primary"
      >
        Export
      </Button>
      <IconButton
        onClick={onRefresh}
        color="primary"
        sx={{
          backgroundColor: '#ffffff',
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        }}
      >
        <Refresh />
      </IconButton>
    </div>
  );
};

export default CommonTableActions;